var _rect, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSell = function SvgSell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 77,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_1751",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_1751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5341 23.2664C8.84503 22.3778 10.1893 21.7002 11.5669 21.2336C12.945 20.7669 14.4229 20.5336 16.0005 20.5336C17.5781 20.5336 19.0613 20.7669 20.4501 21.2336C21.8394 21.7002 23.1896 22.3778 24.5005 23.2664C25.4114 22.1554 26.0725 21 26.4837 19.8C26.8949 18.6 27.1005 17.3333 27.1005 16C27.1005 12.8666 26.0338 10.2333 23.9005 8.09997C21.7672 5.96664 19.1338 4.89997 16.0005 4.89997C12.8672 4.89997 10.2338 5.96664 8.1005 8.09997C5.96717 10.2333 4.9005 12.8666 4.9005 16C4.9005 17.3333 5.1117 18.6 5.5341 19.8C5.95597 21 6.62263 22.1554 7.5341 23.2664ZM16.0005 17.1C14.7114 17.1 13.6226 16.6554 12.7341 15.7664C11.845 14.8778 11.4005 13.789 11.4005 12.5C11.4005 11.2109 11.845 10.1221 12.7341 9.23357C13.6226 8.3445 14.7114 7.89997 16.0005 7.89997C17.2896 7.89997 18.3784 8.3445 19.2669 9.23357C20.156 10.1221 20.6005 11.2109 20.6005 12.5C20.6005 13.8109 20.156 14.9053 19.2669 15.7832C18.3784 16.661 17.2896 17.1 16.0005 17.1ZM16.0005 29.3336C14.1562 29.3336 12.4173 28.9834 10.7837 28.2832C9.15063 27.5834 7.7341 26.628 6.5341 25.4168C5.3341 24.2056 4.38957 22.7944 3.7005 21.1832C3.01143 19.572 2.6669 17.8442 2.6669 16C2.6669 14.1557 3.01703 12.4224 3.7173 10.8C4.41703 9.17757 5.3725 7.76637 6.5837 6.56637C7.7949 5.36637 9.2061 4.4165 10.8173 3.71677C12.4285 3.0165 14.1562 2.66637 16.0005 2.66637C17.8448 2.66637 19.5781 3.0165 21.2005 3.71677C22.8229 4.4165 24.2341 5.36637 25.4341 6.56637C26.6341 7.76637 27.584 9.17757 28.2837 10.8C28.984 12.4224 29.3341 14.1557 29.3341 16C29.3341 17.8442 28.984 19.572 28.2837 21.1832C27.584 22.7944 26.6341 24.2056 25.4341 25.4168C24.2341 26.628 22.8229 27.5834 21.2005 28.2832C19.5781 28.9834 17.8448 29.3336 16.0005 29.3336Z",
    fill: "white"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sell.4c5a1b39.svg";
export { ForwardRef as ReactComponent };